import React from 'react';
import { BsShareFill } from 'react-icons/bs';
import { getButtonText, getCardAction } from '../utils';
import * as nativeEvents from '../../../Helper/native';
import { ASSET_URLS, CAMPAIGN_CONFIG } from '../constants';
import MnthEndFAQ from '../../MnthEndFAQ';
import MthEndTAndC from '../../MthEndTAndC';

const initiaData = require('../../urlEncodeTest.json');

const HeaderBanner = ({ cardType, cardPaymentStatus, onShare }) => {
  const handleCardAction = () => {
    const action = getCardAction(cardType, cardPaymentStatus);
    nativeEvents[action]();
  };

  return (
    <div className="headerImgContainerOneMonth">
      {/* <div className="headerCta">
        <button
          className="shareCta"
          onClick={() => onShare(initiaData.floatingShareMsg.msg)}
        >
          <BsShareFill size={22} color="#FFFFFF" />
        </button>
      </div> */}
      {/* <div className="offerTillTextContainer">
        <span className="offerTillText">
            OFFER TILL 31st JAN
        </span>
      </div> */}
      <div style={{ position: 'relative', marginTop: '50px', textAlign: 'center' }}>
        <div className="head-title-month">{CAMPAIGN_CONFIG.TITLE}</div>
        <div className="cardImgContainer">
        <div className="head-subtitle-month">
          Earn <span className="highlightText">5% Bitcoin</span> rewards on every card spend.
        </div>
        
          {/* {cardType === 'ELITE' ? (
            <div className="head-subtitle-month">
              Earn <span className="highlightText">3% Bitcoin</span> rewards on
              every card spend*
            </div>
          ) : (
            <div className="head-subtitle-month">
              Upgrade to Elite card & enjoy{' '}
              <span className="highlightText">3% Bitcoin</span> rewards on every
              card spend*
            </div>
          )} */}
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '50px',
          width: '100%',
        }}
      >
        <img
          src={ASSET_URLS.DECORATION_2}
          style={{ width: '100%', height: 'auto', marginBottom: '-100px' }}
          alt=""
        />
      </div>
        <button className="addMoneyButton" onClick={handleCardAction}>
          {getButtonText(cardType, cardPaymentStatus)}
        </button>

      <div className="footerContainer" style={{ marginTop: '0px' }}>
        <div style={{ padding: '0px 0px 50px 0px' }}>
          <div style={{ marginBottom: '28px', marginTop: '40px' }}>
            <MnthEndFAQ />
          </div>
          <MthEndTAndC />
        </div>
      </div>
    </div>
  );
};

export default HeaderBanner;
